// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const K8sIoApiCoreV1ConditionStatus = {
  ConditionTrue: 'True',
  ConditionFalse: 'False',
  ConditionUnknown: 'Unknown',
} as const;
export type K8sIoApiCoreV1ConditionStatus =
  (typeof K8sIoApiCoreV1ConditionStatus)[keyof typeof K8sIoApiCoreV1ConditionStatus];

export function instanceOfK8sIoApiCoreV1ConditionStatus(value: any): boolean {
  for (const key in K8sIoApiCoreV1ConditionStatus) {
    if (
      Object.prototype.hasOwnProperty.call(K8sIoApiCoreV1ConditionStatus, key)
    ) {
      if (
        K8sIoApiCoreV1ConditionStatus[
          key as keyof typeof K8sIoApiCoreV1ConditionStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function K8sIoApiCoreV1ConditionStatusFromJSON(
  json: any,
): K8sIoApiCoreV1ConditionStatus {
  return K8sIoApiCoreV1ConditionStatusFromJSONTyped(json, false);
}

export function K8sIoApiCoreV1ConditionStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): K8sIoApiCoreV1ConditionStatus {
  return json as K8sIoApiCoreV1ConditionStatus;
}

export function K8sIoApiCoreV1ConditionStatusToJSON(
  value?: K8sIoApiCoreV1ConditionStatus | null,
): any {
  return value as any;
}

export function K8sIoApiCoreV1ConditionStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): K8sIoApiCoreV1ConditionStatus {
  return value as K8sIoApiCoreV1ConditionStatus;
}
